const degrees = [
  {
    school: 'Duke University',
    degree: 'B.S. Mathematics and Computer Science',
    link: 'https://duke.edu',
    year: 2026,
  },
  {
    school: 'Duke Kunshan University',
    degree: 'B.S. Mathematics and Computer Science',
    link: 'https://dukekunshan.edu.cn',
    year: 2026,
  },
];

export default degrees;
